import React from "react";
import copy from "../lib/copy";

const Metrics = () => (
  <section className="metrics">
    <div className="shell">
      <div className="row">
        {copy.metrics.map((m, i) => (
          <div key={m.label} className="cell">
            <div className="v">
              {m.value}
              {i === 0 && <sub />}
            </div>
            <div className="l">{m.label}</div>
            {m.note && <div className="n">{m.note}</div>}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Metrics;
